var env = {
  claudia_prod: {
    url:'https://062wufy9r4.execute-api.eu-west-1.amazonaws.com/prod/',
  },
  claudia_devprod: {
    url:'https://062wufy9r4.execute-api.eu-west-1.amazonaws.com/prod/',
  },
  claudia_dev: {
    url:'https://062wufy9r4.execute-api.eu-west-1.amazonaws.com/dev/',
  },
  dev:
      {
       url:'https://njoynha205.execute-api.eu-west-1.amazonaws.com/dev/',
      },
  stg:
      {
       url:'https://jemkwf169h.execute-api.eu-west-1.amazonaws.com/stg/',
      },
  prod:
      {
       url:'https://geffe6u3ma.execute-api.eu-west-1.amazonaws.com/prod/',
      },
  claudia_stg: {
    url:'https://062wufy9r4.execute-api.eu-west-1.amazonaws.com/stg/',
  },
  local: {
    url:'http://localhost:3000/',
  },
  stage: 'dev',
  version: '1791470137573',
}

module.exports = env;
